<template>
	<v-card hover height="15rem" class="action-card" :to="routePath(action.id)">
		<v-card-title>
			<h4 class="action-title subheading font-weight-bold">{{ action.title }}</h4>
		</v-card-title>
		<v-divider></v-divider>
		<v-card-text class="description">
			<div class="compiled-md-text multiline-clamp" v-html="compile(action.claim)" />
		</v-card-text>
		<v-card-actions class="footer">
			<action-stats :item="action" />
			<v-spacer></v-spacer>
			<v-rating clearable dense readonly small
				:value="action.risk"
				empty-icon="mdi-alert-outline"
				full-icon="mdi-alert"
				background-color="red darken-3"
				color="red darken-3" />
		</v-card-actions>
	</v-card>
</template>


<script>
import ActionStats from '@/components/ActionStats';
import { compile } from '@/utils/markdown';

export default {
	name: 'action-grid-item',
	components: { ActionStats },
	props: {
		'action': { type: Object, default: () => ({}) },
	},
	methods: {
		compile,
		routePath(id) {
			const filter = this.$store.getters['actions/currentRouteFilter'];
			return { name: 'action-details', params: { filter, id } };
		},
	}
}
</script>


<style scoped lang="less">
	.action-card {
		position: relative;

		.action-title {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.multiline-clamp {
			position: relative;
			height: 7.5rem; // 5 * line-height
			overflow: hidden;

			&::after {
				content: "";
				background: linear-gradient(rgba(255,255,255,0.5), #ffffff);
				position: absolute;
				width: 100%;
				left: 0;
				height: 1.5rem; // 1 * line-height
				bottom: 0;
			}
		}
		.tags {
			margin: 0 -4px;
		}
		.footer {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
		}
	}
</style>